export const codeList = {
  '': 'en',
  '44': 'en',
  '91': 'hi',
  '84': 'vi',
  '886': 'zh-TW',
  '81': 'ja',
  '66': 'th',
  '63': 'ph',
  '49': 'de',
  '33': 'fr',
  '39': 'it',
  '351': 'pt',
  '62': 'id',
  '90': 'tc',
  '60': 'ma',
  '55': 'pt',
}



// WEBPACK FOOTER //
// ./src/components/countrycode.js